var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAudioPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 35 35"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "audio_play_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  d: "M0 0h15.088v15.853H0z",
  "data-name": "Rectangle 6342"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19404",
  transform: "translate(-91 -555.063)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 17.5,
  cy: 17.5,
  r: 17.5,
  fill: "none",
  "data-name": "Ellipse 16",
  transform: "translate(91 555.063)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 15199"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M97 561.062h24v24H97z",
  "data-name": "Rectangle 6441"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 14966"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#audio_play_svg__a)",
  "data-name": "Group 14965",
  transform: "translate(102 565.062)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M1.701 5.377c0-3.275 2.318-4.612 5.144-2.975l2.211 1.274 2.211 1.276c2.828 1.638 2.828 4.316 0 5.952l-2.211 1.275-2.211 1.276c-2.826 1.637-5.144.297-5.144-2.976v-5.1Z",
  "data-name": "Path 6104"
})))))));
export { SvgAudioPlay as ReactComponent };
export default __webpack_public_path__ + "static/media/audio_play.64f8c917c7493dc8c6842c8bf9008abd.svg";